import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import { redirectToExternalLogin } from 'helpers/Location';
import Cookie from 'js-cookie';
import { inject } from 'mobx-react';
import { AuthService } from 'modules/auth';
import PropTypes from 'prop-types';

import { ROUTES, PAGE_TO_REDIRECT } from './constants';

@inject((stores) => ({
  onlineEvent: stores.MembershipStore.onlineEvent
}))
class ProfileBasedRedirect extends Component {
  constructor(props) {
    super(props);

    this.isCurrentPath = this.isCurrentPath.bind(this);
  }

  static propTypes = {
    location: PropTypes.shape({
      pathname: PropTypes.string.isRequired
    }).isRequired,
    onlineEvent: PropTypes.bool
  };

  isCurrentPath(path) {
    const { location = {} } = this.props;
    const { pathname: currentPath } = location;

    return path === currentPath;
  }

  getRedirectPage() {
    return Cookie.get(PAGE_TO_REDIRECT);
  }

  removeRedirectPage() {
    Cookie.remove(PAGE_TO_REDIRECT);
  }

  checkRedirect() {
    const { onlineEvent } = this.props;
    let to = '';
    let shouldRedirect = false;

    if (!AuthService.isLogged) {
      to = ROUTES.LOGIN;

      redirectToExternalLogin(location);

      shouldRedirect = !this.isCurrentPath(ROUTES.LOGIN);
    } else if (this.getRedirectPage()) {
      const redirectRoute = this.getRedirectPage();

      this.removeRedirectPage();
      shouldRedirect = !this.isCurrentPath(redirectRoute);
      to = redirectRoute;
    } else if (AuthService.hasDashboardEnabled && !onlineEvent) {
      shouldRedirect = !this.isCurrentPath(ROUTES.DASHBOARD);
      to = ROUTES.DASHBOARD;
    } else if (AuthService.isModerator()) {
      shouldRedirect = !this.isCurrentPath(ROUTES.COMMUNITY.LIST);
      to = ROUTES.COMMUNITY.LIST;
    } else {
      shouldRedirect = !this.isCurrentPath(ROUTES.CONTENT.LIST);
      to = ROUTES.CONTENT.LIST;
    }

    return {
      shouldRedirect,
      to
    };
  }

  render() {
    const { shouldRedirect, to } = this.checkRedirect();

    return shouldRedirect && <Redirect to={to} />;
  }
}

export default ProfileBasedRedirect;
